import { h, render, Fragment } from 'preact';
import MainView from './views/main.view';
// TODO turn linter back on in the package.json > build command | currently breaking Bamboo builds
export class App {
    constructor(selector) {
        this.rootElement = document.querySelector(selector);
    }

    get app() {
        return (
            <Fragment>
                <main>
                    <MainView />
                </main>
            </Fragment>
        );
    }

    init() {
        render(this.app, this.rootElement);
    }
}
